function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgEsportesELazer = function SvgEsportesELazer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.588 10.312C2.642 4.33 8.348.333 14.331 1.39c5.983 1.055 9.977 6.76 8.922 12.743-1.054 5.982-6.76 9.977-12.742 8.922C4.528 22 .533 16.294 1.588 10.312zm8.126 11.536a9.975 9.975 0 01-5.826-4.412 6.983 6.983 0 014.19-1.525 16.91 16.91 0 001.636 5.937zM2.498 10.98a9.947 9.947 0 00.905 5.567 7.981 7.981 0 014.618-1.634c-.025-.97.032-1.95.175-2.928L2.498 10.98zm8.48 11.137a15.93 15.93 0 01-1.892-6.157 7.004 7.004 0 016.085 5.878 9.95 9.95 0 01-4.194.279zM9.64 15.03a8.004 8.004 0 016.49 6.478 9.994 9.994 0 006.04-7.06L9.182 12.157a16.053 16.053 0 00-.16 2.788c.206.02.412.049.618.085zm-.285-3.858l12.988 2.29a9.995 9.995 0 00-3.26-8.701 8.005 8.005 0 01-8.923 3.736 16.048 16.048 0 00-.805 2.675zm-.148-2.985A17.054 17.054 0 008.37 11L2.672 9.994a9.948 9.948 0 012.754-4.921 7.983 7.983 0 003.781 3.115zm.394-.92a6.985 6.985 0 01-3.415-2.866 9.977 9.977 0 016.986-2.154 16.91 16.91 0 00-3.57 5.02zm.965.3a15.93 15.93 0 013.884-5.139 9.95 9.95 0 013.844 1.696 7.004 7.004 0 01-7.728 3.443z",
    fill: props.color
  }));
};

SvgEsportesELazer.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgEsportesELazer.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgEsportesELazer;